import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/products')({
  beforeLoad: (): never => {
    throw redirect({ to: '/all-products' })
  },
})
